import React from 'react';
import Header from '../../component/global/Header';
import SidebarAdmin from '../../component/global/admin/SidebarAdmin';
import TbRegister from '../../component/global/admin/Table/TbRegister';
import HeaderAdmin from '../../component/global/HeaderAdmin';

export default function RegisterScreen() {
 return (
  <>
   <HeaderAdmin />
   <div className='page-wrapper'>
    <div className='container-fluid'>
     <TbRegister />
    </div>
   </div>
  </>
 )
}